// extracted by mini-css-extract-plugin
export var button = "Button-module--button--sRE36";
export var base = "Button-module--base--yE4-A";
export var small = "Button-module--small--v6X-U";
export var primary = "Button-module--primary--uHAe9";
export var secondary = "Button-module--secondary--m8ggv";
export var outline_inverted = "Button-module--outline_inverted--EaZKd";
export var currentColor_inverted = "Button-module--currentColor_inverted--WtNwj";